import HttpClient from "../HttpClient/HttpClient";
import { getWordDefinitionEndPoint } from "../util/apiEndpoints";

class WordDefinition {
    getWordDefinitionForLanguage = (languageId, token) => {
        const httpClient = new HttpClient(token);
        return httpClient.get(getWordDefinitionEndPoint(languageId))
            .then(res => {
                return res;
            })
    }
}

const wordDefinition = new WordDefinition();
export default wordDefinition;


// WEBPACK FOOTER //
// ./retts/WordDefinition/WordDefinition.js